// src/context/AuthContext.js
import React, { createContext, useState } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    () => !!sessionStorage.getItem('token')
  );

  const login = (data) => {
    // Save token to localStorage
    sessionStorage.setItem('token', data.token);
    sessionStorage.setItem('username', data.email);
    sessionStorage.setItem('userRole', data.role);
    setIsAuthenticated(true);
  };

  const logout = () => {
    // Remove token from localStorage
    sessionStorage.removeItem('token');
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
